import styled from "styled-components"

import Button from "../Button"

export const Link = styled(Button)`
  text-transform: uppercase;
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  line-height: 33px;
  background: transparent;
  border: 2px solid rgb(177, 150, 97);
`
